enum NAVIGATION_TYPE {
  ARROW = 'ARROW',
  PAGINATION = 'PAGINATION',
}

export default NAVIGATION_TYPE
